// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3RKjd","col":"CardReaderDesc_col__1nMj0","label":"CardReaderDesc_label__1u2s8"};